import { Box, Flex, HStack } from '@chakra-ui/react';
import { defineMessage, Trans } from '@lingui/macro';
import cloneDeep from 'lodash.clonedeep';
import { IoMdAddCircleOutline } from 'react-icons/io';

import { FIRST_NAME_FIELDNAME, LAST_NAME_FIELDNAME } from '../../../hooks/useReadAdditionalData';
import { COMMON_GAP, ROUNDED_ELEMENT_PROPS } from '../../../utils/styleUtil';
import ButtonAdd from '../../generic/button/ButtonAdd';
import ButtonDelete from '../../generic/button/ButtonDelete';
import InputText from '../../generic/form/InputText';
import VerticalStack from '../../generic/layout/VerticalStack';
import ShopFeaturesBloc from './features/ShopFeaturesBloc';

const ShopResourceBookByName = ({ shopResource, setShopResource, dataWidthProps, data }) => {
  const canAdd = shopResource.stock == null || shopResource.namingData.length < shopResource.stock;

  const onAddItem = () => {
    if (!canAdd) return;

    const copyNamingData = cloneDeep(data.resource.defaultNamingData);
    const newItems = [...shopResource.namingData, copyNamingData[0]];
    setShopResource(newItems.length, newItems);
  };

  const onDeleteItem = index => {
    if (shopResource.namingData.length <= 1) return;

    const newItems = shopResource.namingData.filter((_, i) => i !== index);
    setShopResource(newItems.length, newItems);
  };

  const onItemChange = (index, fieldName, value) => {
    const newItems = [...shopResource.namingData];
    newItems[index] = { ...newItems[index], [fieldName]: value };
    setShopResource(newItems.length, newItems);
  };

  return (
    <Flex gap={COMMON_GAP} flexDirection={{ base: 'column', sm: 'row' }} alignItems="flex-start" w="full">
      <Box flex="1">
        <VerticalStack>
          {shopResource.namingData.map((item, index) => (
            <Box key={index} bg="brand.background_main" position="relative" {...ROUNDED_ELEMENT_PROPS}>
              <HStack>
                <InputText
                  fieldName={FIRST_NAME_FIELDNAME + '_' + index}
                  fieldLabel={firstnameLabel}
                  fieldPlaceholder="John"
                  fieldValue={item.first_name}
                  onChange={(fName, value) => onItemChange(index, 'first_name', value)}
                  isRequired
                />
                <InputText
                  fieldName={LAST_NAME_FIELDNAME + '_' + index}
                  fieldLabel={lastnameLabel}
                  fieldPlaceholder="Doe"
                  fieldValue={item.last_name}
                  onChange={(fName, value) => onItemChange(index, 'last_name', value)}
                  isRequired
                />

                {shopResource.namingData.length > 1 && index > 0 && (
                  <ButtonDelete onClick={() => onDeleteItem(index)} position="absolute" enableSpinner={false} />
                )}
              </HStack>

              <ShopFeaturesBloc data={data} dataWidthProps={dataWidthProps} resourceNamingIndex={index} />
            </Box>
          ))}

          {canAdd && (
            <Flex justifyContent="center">
              <Box>
                <ButtonAdd onClick={onAddItem} icon={IoMdAddCircleOutline} addText>
                  <Trans>Add</Trans>
                </ButtonAdd>
              </Box>
            </Flex>
          )}
        </VerticalStack>
      </Box>
    </Flex>
  );
};

export default ShopResourceBookByName;

const firstnameLabel = defineMessage({ message: 'First name' });
const lastnameLabel = defineMessage({ message: 'Last name' });
